<template>
    <rental-schedule-view @save="save">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #loader>
            <v-fade-transition>
                <v-overlay v-show="loading" absolute light color="white">
                    <v-col class="text-center">
                        <v-progress-circular size="100" width="5" color="black" indeterminate class="ma-4" /> <br />
                        <span class="black--text caption"> 요청을 취합하고 있습니다. </span>
                    </v-col>
                </v-overlay>
            </v-fade-transition>
        </template>
    </rental-schedule-view>
</template>

<script>
import api from "@/api";
import RentalScheduleView from "./rental-schedule-view.vue";

export default {
    components: {
        RentalScheduleView,
    },
    data: () => ({
        loading: false,
    }),
    methods: {
        async save(requests = []) {
            this.loading = true;
            try {
                for (const request of requests) {
                    await api.console.rental.requests.post(request);
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>